export default {
  id: 'audit',
  nav: [{ group: 'admin', label: 'Audit log', path: '/audit', icon: 'list', order: 130, permission: 'audit.read', match: /^\/audit/ }],
  routes: [
    { path: '/audit', title: 'Audit log', permission: 'audit.read', breadcrumbs: ['Administration', 'Audit log'], view: () => import('./views/audit.view.js') },
  ],
};
